import { useCallback, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { BookingFlight, FLIGHT_STATUS_LABEL } from "src/store/reducers/bookings";
import AddFlightBookingCanvas from "./AddFlightBookingCanvas";
import EditBookingFlightCanvas from "./EditBookingFlightCanvas";

interface ListBookingFlightsProps {
  bookingId: string;
  bookingFlightData: BookingFlight[];
  setDeleteFlightId: React.Dispatch<React.SetStateAction<string | undefined>>;
}
function ListBookingFlights({
  bookingId,
  bookingFlightData,
  setDeleteFlightId,
}: ListBookingFlightsProps) {
  const [editFlightId, setEditFlightId] = useState<number>();
  const [showFlightAddModal, setShowFlightAddModal] = useState(false);
  const [show, setShow] = useState(bookingFlightData.length > 0);
  const toggleShow = useCallback(() => {
    setShow((show) => !show);
  }, []);
  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="col-xl-12 col-xxl-12">
            <div className="card h-auto">
              <div className="card-header">
                <h4
                  className="heading mb-0 link"
                  role="button"
                  onClick={toggleShow}
                >
                  {show ? (
                    <span className="btn-icon-start">
                      <i className="fa fa-minus color-info"></i>
                    </span>
                  ) : (
                    <span className="btn-icon-start">
                      <i className="fa fa-plus color-info"></i>
                    </span>
                  )}
                  Flights
                </h4>
                <Link
                  to={"#"}
                  className="btn btn-primary btn-sm"
                  data-bs-toggle="offcanvas"
                  onClick={() => setShowFlightAddModal(true)}
                >
                  + Add Flight
                </Link>
              </div>
              <div className={!show ? "card-body d-none" : "card-body"}>
                {bookingFlightData.length > 0 ? (
                  <div className="table-responsive active-projects">
                    <div
                      id="projects-tbl_wrapper"
                      className="dataTables_wrapper no-footer"
                    >
                      <table
                        id="projects-tbl"
                        className="table table-hover dataTable no-footer mb-0"
                      >
                        <thead>
                          <tr>
                            <th>Airline</th>
                            <th>Flight No.</th>
                            <th>From</th>
                            <th>To</th>
                            <th>Departure</th>
                            <th>Arrival</th>
                            <th>Class</th>
                            <th>Customer Fare</th>
                            <th>Company Fare</th>
                            <th>PNR</th>
                            <th>Travel Agent</th>
                            <th>Status</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {bookingFlightData?.map((flightData, index) => (
                            <tr key={flightData.id}>
                              <td>{flightData.airline_name}</td>
                              <td>{flightData.flight_number}</td>
                              <td>{flightData.departure_airport}</td>
                              <td>{flightData.arrival_airport}</td>
                              <td>
                                {new Date(
                                  flightData.departure_datetime
                                ).toLocaleString('en-IN')}
                              </td>
                              <td>
                                {new Date(
                                  flightData.arrival_datetime
                                ).toLocaleString('en-IN')}
                              </td>
                              <td>{flightData.flight_class}</td>
                              <td>{flightData.fare}</td>
                              <td>{flightData.company_fare}</td>
                              <td>{flightData.pnr_number}</td>
                              <td>{flightData.travel_agent?.name ?? "-"}</td>
                              <td>{FLIGHT_STATUS_LABEL[flightData.flight_status]}</td>
                              <td>
                                <NavLink
                                  className="btn btn-primary shadow btn-xs sharp me-1"
                                  onClick={() => setEditFlightId(index)}
                                  to={`#`}
                                  title="Edit"
                                >
                                  <i className={`fas fa-pen`} />
                                </NavLink>{" "}
                                <NavLink
                                  className="btn btn-danger shadow btn-xs sharp"
                                  onClick={() => {
                                    setDeleteFlightId(flightData.id);
                                  }}
                                  to={`#`}
                                  title="Delete"
                                >
                                  <i className={`fas fa-x`} />
                                </NavLink>{" "}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                ) : (
                  <div className="d-flex align-items-center">
                    &nbsp;
                    <strong>Add flights for this booking </strong>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <AddFlightBookingCanvas
        Title={"Add Flight"}
        show={showFlightAddModal}
        bookingId={bookingId}
        setShow={setShowFlightAddModal}
      />
      <EditBookingFlightCanvas
        editId={
          typeof editFlightId !== "undefined"
            ? bookingFlightData?.[editFlightId]?.id
            : ""
        }
        Title={"Edit Flight"}
        data={
          typeof editFlightId !== "undefined"
            ? bookingFlightData?.[editFlightId]
            : undefined
        }
        hide={() => setEditFlightId(undefined)}
      />
    </>
  );
}

export default ListBookingFlights;
